import { PASSWORD_REQUIREMENTS } from "./utils/content";
import "./index.scss";

export const PasswordTooltipContent = () => {
  return (
    <div
      className="password-tooltip-content-container"
      data-testid="password-tooltip-content"
    >
      <div className="content-header">
        <p>Password Requirements:</p>
      </div>
      <div className="content-container">
        <ul className="requirement-list">
          {PASSWORD_REQUIREMENTS.map((item) => (
            <li className="requirement-item" key={item.id}>
              {item.value}
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};
